import { Injectable } from '@angular/core';
import { LocalStorageManager } from '@examdojo/browser/local-storage';

@Injectable({
  providedIn: 'root',
})
export class ActiveSyllabusManager {
  readonly storage = new LocalStorageManager<{
    syllabusSlug?: string;
  }>('active-syllabus');

  getActiveSyllabusSlug(): string | null {
    return this.storage.getValue()?.syllabusSlug ?? null;
  }

  setActiveSyllabusSlug(slug: string): void {
    this.storage.setValue({ syllabusSlug: slug });
  }

  clearActiveSyllabus(): void {
    this.storage.setValue({});
  }
}
